/* previewLibrary.js — loader + validation + helpers for the AI-Agent Preview Library.
   Source: served via /api/content/specialization_previews.json (auth-gated). */
import { loadContent } from './contentLoader';

const PROGRAM_BY_SLUG = { btech: 'B.Tech', bba: 'BBA', mba: 'MBA' };
const SLUG_BY_PROGRAM = { 'B.Tech': 'btech', BBA: 'bba', MBA: 'mba' };
const EXPECTED_COUNTS = { 'B.Tech': 83, BBA: 25, MBA: 35 };
const EXPECTED_TOTAL = 143;

let cachePromise = null;

export function loadPreviewLibrary() {
  if (!cachePromise) {
    cachePromise = loadContent('specialization_previews.json')
      .then((d) => {
        if (!d) throw new Error('Preview library unavailable');
        return d;
      })
      .catch((e) => {
        cachePromise = null;
        throw e;
      });
  }
  return cachePromise;
}

/* Validation: counts must match 83 / 25 / 35 = 143. Warn, never break. */
export function validateLibrary(data) {
  const counts = {};
  const problems = [];
  const programs = data?.programs || {};
  Object.entries(EXPECTED_COUNTS).forEach(([prog, expected]) => {
    const actual = Array.isArray(programs[prog]) ? programs[prog].length : 0;
    counts[prog] = actual;
    if (actual !== expected) problems.push(`${prog}: expected ${expected}, found ${actual}`);
  });
  Object.keys(programs).forEach((prog) => {
    if (!(prog in EXPECTED_COUNTS)) {
      counts[prog] = programs[prog]?.length || 0;
      problems.push(`Unexpected program "${prog}" (${counts[prog]} records)`);
    }
  });
  const total = Object.values(counts).reduce((a, b) => a + b, 0);
  if (total !== EXPECTED_TOTAL) problems.push(`Total: expected ${EXPECTED_TOTAL}, found ${total}`);
  return { ok: problems.length === 0, counts, total, problems };
}

export const programSlug = (program) => SLUG_BY_PROGRAM[program];
export const programFromSlug = (slug) => PROGRAM_BY_SLUG[(slug || '').toLowerCase()];
export const PROGRAM_ORDER = ['B.Tech', 'BBA', 'MBA'];

/* "tasks_ai_agents_may_automate" → "Tasks AI agents may automate" (AI kept uppercase) */
export function humanize(key) {
  const words = String(key).split('_').map((w) => (w.toLowerCase() === 'ai' ? 'AI' : w));
  const sentence = words.join(' ');
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
}

/* Find a record by program title match (used for related_specializations links) */
export function findByTitle(records, title) {
  return (records || []).find((r) => r.title === title) || null;
}
